import classnames from 'classnames'

const AvailabilityLegendItem = ({ color, text }) => (
    <div className="legend-item">
        <div className={classnames('legend-status', color)} />
        <div>{text}</div>
    </div>
)

export default AvailabilityLegendItem
